<div class="bcms-games-container mobile bcms-padding" [hidden]="message.desktopGames.length === 0 && !message.isAllDesktopGames">
    <div class="bcms-games-wrapper">
        <div [hidden]="message.desktopGames.length === 0" class="bcms-games">
            @if (message.desktopGames.length <= 3) {
                <div class="bcms-games-img-container no-slider">
                    @for (game of message.desktopGames; track trackByTitle($index, game)) {
                        <div class="bcms-single-game-container">
                            <a class="bcms-game-img-link dh">
                                <div class="bcms-game-locked">
                                    <vn-icon
                                        name="theme-locked"
                                        extraClass="ui-icon ui-icon-size-xl d-flex justify-content-center align-items-center" />
                                    <vn-image [src]="game.icon.src" [alt]="game.title" [width]="140" [height]="140" imageClass="bcms-game-img" />
                                </div>
                            </a>
                        </div>
                    }
                </div>
            } @else {
                <vn-swiper [swiperOptions]="{ slidesPerView, navigation: arrows }" swiperClass="bcms-games-img-container">
                    @for (game of message.desktopGames; track trackByTitle($index, game)) {
                        <div class="swiper-slide">
                            <div class="bcms-single-game-container">
                                <a class="bcms-game-img-link dh">
                                    <div class="bcms-game-locked">
                                        <vn-icon
                                            name="theme-locked"
                                            extraClass="ui-icon ui-icon-size-xl d-flex justify-content-center align-items-center" />
                                        <vn-image [src]="game.icon.src" [alt]="game.title" [width]="140" [height]="140" imageClass="bcms-game-img" />
                                    </div>
                                </a>
                            </div>
                        </div>
                    }
                </vn-swiper>
            }
        </div>
    </div>
</div>
